// extracted by mini-css-extract-plugin
export default {"list":"Games_list__64Ify"};